import React from "react";
import { styled } from "@mui/system";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import Select from "../Select/Select";
import MenuItem from "../MenuItem/CustomMenuItem";

const StyledContainer = styled("div")(() => ({
  margin: "6px 0px",
  width: "100%",
}));

const findLabelByValue = (selectedValue, menuItems) => {
  const selectedMenuItem = menuItems.find(
    (menuItem) => menuItem.value === selectedValue,
  );
  return selectedMenuItem ? selectedMenuItem.label : null;
};

const SingleSelect = (props) => {
  const {
    id,
    name,
    value,
    label,
    handleChange,
    menuItems,
    defaultSelected,
    errorMessage,
    disabled,
  } = props;
  const selectProps = {
    id,
    name,
    value,
    label,
  };


  return (
    <StyledContainer>
      <Select
        {...selectProps}
        multiline
        defaultValue={defaultSelected}
        renderValue={(selected) => {
          const selectedLabel = findLabelByValue(selected, menuItems);
          if (!selectedLabel) {
            return <em>{selected}</em>;
          }
          return selectedLabel;
        }}
        onChange={handleChange}
        disabled={disabled}
      >
        {menuItems.map((menuItem) => (
          <MenuItem key={menuItem.key} value={menuItem.value}>
            {menuItem.label}
          </MenuItem>
        ))}
      </Select>
      {errorMessage ? <ErrorMessage>{errorMessage}</ErrorMessage> : null}
    </StyledContainer>
  );
};

export default SingleSelect;
